var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"LoginService"},[_c('a-spin',{attrs:{"spinning":_vm.spinning,"tip":"页面跳转中，请稍后~"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }